import { AccordionBody, AccordionHeader, AccordionItem } from "../../Accordion";
import RadioCard from "../../RadioCard";
import ValidatedField from "../../form/ValidatedField";
import {
  RevisorsSectionProps,
  scrollToRefIfNotInView,
} from "../RevisorsErklaering";

export default function RevisorsHandling10(props: RevisorsSectionProps) {
  const { locked, isCompleteHelpers, formikProps, refs, texts } = props;
  const { revisors_handling_10 } = texts;
  const { values, errors, touched } = formikProps;
  return (
    <AccordionItem
      value="Handling10"
      className={
        values.advokatens_section_1_4_dispensation_ja_nej === "Nej"
          ? "disabled"
          : ""
      }
    >
      <AccordionHeader
        sectionStarted={!!values.revisors_handling_10_question}
        sectionComplete={isCompleteHelpers.revisors_handling_10_complete}
        ref={refs.handling_10_ref}
        onClick={() => {
          scrollToRefIfNotInView(refs.handling_9_ref);
        }}
      >
        {revisors_handling_10.title}
      </AccordionHeader>
      <AccordionBody>
        <fieldset
          disabled={
            values.advokatens_section_1_4_dispensation_ja_nej === "Nej" ||
            locked
          }
        >
          {values.advokatens_section_1_4_dispensation_ja_nej === "Nej" && (
            <div className="callout callout-danger mb-3" role="alert">
              Handling 10 er ikke relevant, da advokat ikke har angivet at der
              er givet dispensation.
            </div>
          )}
          <legend className="h5 fw-normal mb-4 lh-base">
            {revisors_handling_10.description}
          </legend>
          <div className="vstack gap-3" role="group">
            <RadioCard
              name={revisors_handling_10.revisors_handling_10_question.id}
              id={
                revisors_handling_10.revisors_handling_10_question
                  .revisors_handling_10_question_alt_1.value
              }
              value={
                revisors_handling_10.revisors_handling_10_question
                  .revisors_handling_10_question_alt_1.value
              }
              text={
                <>
                  {
                    revisors_handling_10.revisors_handling_10_question
                      .revisors_handling_10_question_alt_1.labelPart1
                  }{" "}
                  <div className="d-inline-block position-relative">
                    <ValidatedField
                      additionalClasses={`m-1 py-1 ${
                        errors.revisors_handling_10_alt_1_dispensationDato &&
                        touched.revisors_handling_10_alt_1_dispensationDato
                          ? "ps-2 pe-5"
                          : "px-2"
                      }`}
                      touched={
                        touched.revisors_handling_10_alt_1_dispensationDato
                      }
                      error={errors.revisors_handling_10_alt_1_dispensationDato}
                      type="date"
                      style={{ width: 146 }}
                      name={
                        revisors_handling_10.revisors_handling_10_question
                          .revisors_handling_10_question_alt_1
                          .revisors_handling_10_alt_1_dispensationDato.id
                      }
                      autoComplete="off"
                    />
                  </div>{" "}
                  {
                    revisors_handling_10.revisors_handling_10_question
                      .revisors_handling_10_question_alt_1.labelPart2
                  }{" "}
                  <div className="d-inline-block position-relative">
                    <ValidatedField
                      additionalClasses={`m-1 py-1 ${
                        errors.revisors_handling_10_alt_1_dispensationPeriodeDatoFra &&
                        touched.revisors_handling_10_alt_1_dispensationPeriodeDatoFra
                          ? "ps-2 pe-5"
                          : "px-2"
                      }`}
                      touched={
                        touched.revisors_handling_10_alt_1_dispensationPeriodeDatoFra
                      }
                      error={
                        errors.revisors_handling_10_alt_1_dispensationPeriodeDatoFra
                      }
                      type="date"
                      style={{ width: 146 }}
                      name={
                        revisors_handling_10.revisors_handling_10_question
                          .revisors_handling_10_question_alt_1
                          .revisors_handling_10_alt_1_dispensationPeriodeDatoFra
                          .id
                      }
                      autoComplete="off"
                    />
                  </div>{" "}
                  {
                    revisors_handling_10.revisors_handling_10_question
                      .revisors_handling_10_question_alt_1.labelPart3
                  }{" "}
                  <div className="d-inline-block position-relative">
                    <ValidatedField
                      touched={
                        touched.revisors_handling_10_alt_1_dispensationPeriodeDatoTil
                      }
                      error={
                        errors.revisors_handling_10_alt_1_dispensationPeriodeDatoTil
                      }
                      additionalClasses={`m-1 py-1 ${
                        errors.revisors_handling_10_alt_1_dispensationPeriodeDatoTil &&
                        touched.revisors_handling_10_alt_1_dispensationPeriodeDatoTil
                          ? "ps-2 pe-5"
                          : "px-2"
                      }`}
                      type="date"
                      style={{
                        width: 146,
                      }}
                      name={
                        revisors_handling_10.revisors_handling_10_question
                          .revisors_handling_10_question_alt_1
                          .revisors_handling_10_alt_1_dispensationPeriodeDatoTil
                          .id
                      }
                      autoComplete="off"
                    />
                  </div>
                  {"."}
                </>
              }
            ></RadioCard>
            <RadioCard
              name={revisors_handling_10.revisors_handling_10_question.id}
              id={
                revisors_handling_10.revisors_handling_10_question
                  .revisors_handling_10_question_alt_2.value
              }
              value={
                revisors_handling_10.revisors_handling_10_question
                  .revisors_handling_10_question_alt_2.value
              }
              text={
                revisors_handling_10.revisors_handling_10_question
                  .revisors_handling_10_question_alt_2.label
              }
            >
              <label
                htmlFor={
                  revisors_handling_10.revisors_handling_10_alt_2_uddybning.id
                }
                className="mb-2"
              >
                {
                  revisors_handling_10.revisors_handling_10_alt_2_uddybning
                    .label
                }
              </label>
              <ValidatedField
                touched={touched.revisors_handling_10_alt_2_uddybning}
                error={errors.revisors_handling_10_alt_2_uddybning}
                autoComplete="off"
                as="textarea"
                id={
                  revisors_handling_10.revisors_handling_10_alt_2_uddybning.id
                }
                name={
                  revisors_handling_10.revisors_handling_10_alt_2_uddybning.id
                }
                placeholder="Beskrivelse"
                rows={2}
              />
            </RadioCard>
          </div>
        </fieldset>
      </AccordionBody>
    </AccordionItem>
  );
}
